module.exports = __webpack_public_path__ + "static/img/充值_2.478bcd15.png";